import { addQueryParamsUrl, BznavAppIds } from '@repo/common-utils';
import { useCommonRouter } from '@repo/platform';
import { ReactNode, useCallback, useEffect } from 'react';

import { AUTH_QUERY_PARAMETERS } from '../constants';
import { saveReturnUrl } from '../utils';

import { useAppSignInContext } from './AppSignProvider';
import { useAuthContext } from './AuthProvider';

export const AuthGuard = ({ children, logoutPagePath }: { children: ReactNode; logoutPagePath?: string }) => {
  const router = useCommonRouter();
  const { auth, isAllowAuthGuard, authService, isUseCI } = useAuthContext();
  const { isAppSignInProcedure, signRequiredStep } = useAppSignInContext();

  const removeAuthQueryParameters = useCallback(() => {
    AUTH_QUERY_PARAMETERS.forEach((key) => {
      delete router.query[key];
    });
  }, [router.query]);

  useEffect(() => {
    if (!router.isReady || isAppSignInProcedure || auth.status === 'checking' || !isAllowAuthGuard || !authService) return;

    if (auth.status === 'logout') {
      router.replace(logoutPagePath ?? authService.signPaths.signOut);
    } else if (auth.status === 'login') {
      if ('code' in router.query) {
        removeAuthQueryParameters();
        const queryString = new URLSearchParams(router.query as Record<string, string>).toString();
        router.replace(`${router.pathname}${queryString ? `?${queryString}` : ''}`);
      } else if (isUseCI && signRequiredStep.ciAuthentication && router.pathname !== authService.signPaths.ciCollectionRequest) {
        router.replace(
          `${authService.signPaths.ciCollectionRequest}?return_url=${encodeURIComponent(addQueryParamsUrl(router.pathname, router.query as Record<string, string>))}`
        );
      } else if (!auth.user?.signAppIds?.includes(process.env.NEXT_PUBLIC_APP_ID as BznavAppIds)) {
        saveReturnUrl(router.pathname);
        router.replace(authService.signPaths.signUpTerms);
      }
    }
  }, [
    auth,
    authService,
    isAllowAuthGuard,
    isAppSignInProcedure,
    isUseCI,
    logoutPagePath,
    removeAuthQueryParameters,
    router,
    signRequiredStep.ciAuthentication
  ]);

  if (auth.status === 'login' && !isAppSignInProcedure) {
    return <>{children}</>;
  }
  return <></>;
};
